import React from 'react'
import PropTypes from 'prop-types'

const HamburgerIcon = ({ width = 32, height = 32, title = 'Menu' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="HamburgerIcon"
    width={width}
    height={height}
    viewBox="0 0 40 40"
  >
    <title>{title}</title>
    <path d="M7.58374 11.4H32.4162" stroke="#F6F6F6" strokeWidth="2.23361" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.58374 20H32.4162" stroke="#F6F6F6" strokeWidth="2.23361" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.58374 28.6H32.4162" stroke="#F6F6F6" strokeWidth="2.23361" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

HamburgerIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  title: PropTypes.string,
}

export default HamburgerIcon
